export async function fetchNews(language) {
  const response = await fetch(`/api/news?lang=${encodeURIComponent(language)}`);
  if (!response.ok) {
    throw new Error("Cannot load news");
  }
  return response.json();
}

export async function fetchNewsItem(id, language) {
  const response = await fetch(`/api/news/${id}?lang=${encodeURIComponent(language)}`);
  if (response.status === 404) {
    return null;
  }
  if (!response.ok) {
    throw new Error("Cannot load news");
  }
  return response.json();
}
